import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
const testimonials = [{
  quote: 'Переїхав до Києва з іншого міста й не знав, з чого почати. Хлопці все зробили за мене — через 2 дні вже мав прописку. Жодних черг і нервів.',
  author: 'Андрій М.',
  role: 'Клієнт'
}, {
  quote: 'Потрібна була прописка для оформлення документів. Проконсультували безкоштовно, одразу запропонували рішення. Все офіційно, все швидко. Рекомендую.',
  author: 'Олександр К.',
  role: 'Клієнт'
}, {
  quote: 'Раніше намагався зробити сам — відмовили двічі. Звернувся сюди, підготували документи правильно, з першого разу все пройшло. Дякую за професіоналізм.',
  author: 'Віталій С.',
  role: 'Клієнт'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-surface" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-163">
            Відгуки клієнтів
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-164">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border flex flex-col" data-id="element-165">
              <p className="text-lg text-primary leading-relaxed mb-8 flex-grow" data-id="element-166">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-167">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-secondary" data-id="element-168">
                  <User size={18} data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <div className="font-medium text-sm text-primary" data-id="element-171">
                    {item.author}
                  </div>
                  <div className="text-xs text-secondary" data-id="element-172">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-12" data-id="element-173">
          <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-medium hover:opacity-80 transition-opacity" data-id="element-174">
            <span className="text-2xl" data-id="element-175">⭐⭐⭐⭐⭐</span>
            <span data-id="element-176">Читати всі відгуки на Google →</span>
          </a>
        </motion.div>
      </div>
    </section>;
}